import axios from '../config/axiosConfig'

export const verificarPaciente = (doc, pass) => {
  const documentoQuery = `?documento=${doc}`
  const passwordQuery = `&password=${pass}`
  return axios.get(`/verificarpaciente${documentoQuery}${passwordQuery}`).then(response => response.data)
}

export const registrarPaciente = (patient) => {
  return axios.post('/registrarpaciente', { ...patient }).then(response => response.data)
}

export const actualizarPaciente = (patient) => {
  const url = '/actualizarpaciente'
  return axios.post(url, { ...patient }).then(response => response.data)
}

export const recuperarPassword = (user) => {
  const url = '/recuperarpassword'
  const documentQuery = `?documento=${user.documento}`
  const emailQuery = `&email=${user.email}`
  return axios.get(`${url}${documentQuery}${emailQuery}`).then(response => response.data)
}
